import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  SuggestedTopicsLoadFulfilledAction,
  SuggestedTopicsLoadMoreFulfilledAction,
} from '../../domains/suggestedTopics/actions.types';
import { FollowTopicAction, UnfollowTopicAction } from '../../domains/topicFollow/actions.types';
import { TopicHeaderLoadAction } from '../../domains/topicHeaderLoad/actions.types';
import { CreateCuratedTopicFulfilledAction } from '../../domains/topics/createCurateActions.types';
import { TopicCurateAction } from '../../domains/topics/curateActions.types';
import { TopicEditAction } from '../../domains/topics/editActions.types';
import { RemoveCuratedTopicFulfilledAction } from '../../domains/topics/removeCuratedActions.types';
import { RemoveTopicFulfilledProps } from '../../domains/topics/removeTopicActions';
import { RemoveTopicFulfilledAction } from '../../domains/topics/removeTopicActions.types';
import {
  TopicsCuratedLoadFulfilledAction,
  TopicsCuratedLoadMoreFulfilledAction,
} from '../../domains/topicsCurated/actions.types';
import { TopicsFollowedLoadAction, TopicsFollowedLoadMoreAction } from '../../domains/topicsFollowedLoad/actions.types';
import {
  TrendingTopicsLoadFulfilledAction,
  TrendingTopicsLoadMoreFulfilledAction,
} from '../../domains/trendingTopicsLoad/actions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';

import { TopicPermissions } from './types';

export type TopicPermissionAction =
  | FollowTopicAction
  | TopicHeaderLoadAction
  | UnfollowTopicAction
  | TopicCurateAction
  | CreateCuratedTopicFulfilledAction
  | TopicEditAction
  | TrendingTopicsLoadFulfilledAction
  | TrendingTopicsLoadMoreFulfilledAction
  | TopicsCuratedLoadFulfilledAction
  | TopicsCuratedLoadMoreFulfilledAction
  | SuggestedTopicsLoadFulfilledAction
  | SuggestedTopicsLoadMoreFulfilledAction
  | RemoveCuratedTopicFulfilledAction
  | TopicsFollowedLoadAction
  | TopicsFollowedLoadMoreAction
  | TypeaheadFulfilledAction
  | RemoveTopicFulfilledAction;

const initialState: TopicPermissions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const removeTopic = (state: TopicPermissions, topicIds: RemoveTopicFulfilledProps) => {
  const curatedTopicId = topicIds?.curatedTopicId;

  return curatedTopicId ? remove(state, [curatedTopicId]) : state;
};

const reducer: Reducer<TopicPermissions, TopicPermissionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC_HEADER.LOAD_PENDING':
      return moveToPending(state, [action.payload.topicId]);
    case 'TOPIC_HEADER.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.topicId], action.payload.error);
    case 'TOPIC_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TRENDING_TOPICS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TRENDING_TOPICS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPICS_FOLLOWED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPICS_FOLLOWED.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPIC.CURATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPIC.CREATE_AND_CURATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPICS_CURATED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TOPICS_CURATED.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'SUGGESTED_TOPICS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'SUGGESTED_TOPICS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicPermissions);
    case 'CURATED_TOPIC.REMOVE_FULFILLED':
      return remove(state, [action.payload.topicId]);
    case 'TOPIC.REMOVE_FULFILLED':
      return removeTopic(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
